import { Paper, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BrandsFilterItems from "./BrandsFilterItems";

interface BrandsFilterCardProps {
  brandOptions: string[];
  selectedBrand: string;
  onSelectedBrandChange: (brand: string) => void;
}

export default function BrandsFilterCard({
  brandOptions,
  selectedBrand,
  onSelectedBrandChange,
}: BrandsFilterCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: "18px 22px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2.25,
        borderColor: "#ececec",
      }}
    >
      <BrandsFilterItems
        options={brandOptions}
        selectedBrand={selectedBrand}
        onSelectedBrandChange={onSelectedBrandChange}
      />
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ ml: "auto", color: "#9e9e9e" }}
      >
        <InfoOutlinedIcon fontSize="small" sx={{ color: "#8E24AA", fontSize: 16 }} />
        <Typography variant="caption" sx={{ fontSize: 13 }}>
          All figures aggregated month-to-date - powered by BQL
        </Typography>
      </Stack>
    </Paper>
  );
}
